export const decrypt = (encryptedBase64: string) => {
  return atob(encryptedBase64);
};
